import { fetchUnassignedCycleCounts } from '../../../services/cycleCountServices'

// The batch services cap one request at 500 ids and the list renders at most 100 rows per batch,
// so "assign the whole pool" walks the paged endpoint and sends the ids in chunks.
export const collectUnassignedIds = async ({ warehouseId, origin, fetch = fetchUnassignedCycleCounts, perPage = 500 }) => {
  const ids = []
  let page = 1
  let totalPages = 1
  do {
    const params = { warehouse_id: warehouseId, page, per_page: perPage }
    if (origin) params.origin = origin
    const res = await fetch(params)
    ids.push(...(res?.data ?? []).map(r => r.id))
    totalPages = res?.meta?.total_pages ?? 1
    page += 1
  } while (page <= totalPages)
  return ids
}

export const chunk = (ids, size = 500) => {
  const out = []
  for (let i = 0; i < ids.length; i += size) out.push(ids.slice(i, i + size))
  return out
}
